import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { SupplierTicket, TicketReply } from '../../models/SupplierTicket/SupplierTicket-model';
import { Observable } from 'rxjs/Observable';


import { Router } from "@angular/router";


import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class SupplierTicketService {
  constructor(private http: Http, private readonly router: Router, private cookieService: CookieService) { }
  private serviceName = 'api/SupplierTicket';


  getSupplierTicket() {
    return this.http.get(`${this.serviceName}`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  addSupplierTicket(SupplierTicketModel: SupplierTicket) {
    

    return this.http.post(`${this.serviceName}/CreateSupplierTicket`, SupplierTicketModel, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  addTicketReply(formData: any) {


    return this.http.post(`${this.serviceName}/CreateTicketReply`, formData, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  AddBlogLogo(formData: any): void {
    this.http
      .post(`${this.serviceName}/SaveBlogLogo`, formData, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .subscribe(result => {
        setTimeout(() => {
          this.router.navigate(["/blog-list"]);
        }, 1000);

      });
  }
  updateSupplierTicket(SupplierTicketModel: SupplierTicket) {
    return this.http.post(`${this.serviceName}/UpdateSupplierTicket`, SupplierTicketModel, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  deleteSupplierTicket(id: string) {
    return this.http.get(`${this.serviceName}/DeleteSupplierTicket?id=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .subscribe(result => {
      });
  
  }

  getDepartments() {
 return this.http.get(`${this.serviceName}/GetDepartments`)
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  getStatus() {
    return this.http.get(`${this.serviceName}/GetStatus`)
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getSupplierTicketById(SupplierTicketId: string) {
    return this.http.get(`${this.serviceName}/GetSupplierTicketById?id=` + SupplierTicketId)
      
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  errorHandler(error: Response) {
    
    return Observable.throw(error);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/SupplierTicket/SupplierTicket.service.ts